import NumberFormat from 'react-number-format';
import InputMask from 'react-input-mask';

export function BirthDateMask(props) {
    const { inputRef, onChange, ...other } = props;
    
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        allowEmptyFormatting={true}
        mask={'_'}
        format='##/##/####'
      />
    );
  }

  export function PhoneNumberMask(props) {
    const { inputRef, onChange, ...other } = props;
    
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        allowEmptyFormatting={true}
        mask={'_'}
        format='+90(###) ### ## ##'
        style={{fontFamily:'SommetRoundedLight',fontSize:'16px'}}
      />
    );
  }

  export function PhoneNumberMask2Digit(props) {
    const { inputRef, onChange, ...other } = props;
    
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        allowEmptyFormatting={true}
        mask={'_'}
        format='+90(***) *** ** ##'
        style={{fontFamily:'SommetRoundedLight',fontSize:'16px'}}
      />
    );
  }

  export function TCKNMask(props) {
    const { inputRef, onChange, ...other } = props;
    
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        allowEmptyFormatting={true}
        mask={'_'}
        format='###########'
        style={{fontFamily:'SommetRoundedLight',fontSize:'16px'}}
      />
    );
  }

  export function VKNMask(props) {
    const { inputRef, onChange, ...other } = props;
    
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        allowEmptyFormatting={true}
        mask={'_'}
        format='##########'
        style={{fontFamily:'SommetRoundedLight',fontSize:'16px'}}
      />
    );
  }
  export function numericMask(props) {
    const { inputRef, onChange, ...other } = props;
    
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        allowEmptyFormatting={true}
      />
    );
  }

  export function FibaKodMask(props) {
    const { inputRef, onChange,format, ...other } = props;
    return (
      <InputMask
        {...other}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        alwaysShowMask={true}
        maskChar={'_'}
        mask={format}
        type="text"
        style={{fontFamily:'SommetRoundedLight',fontSize:'16px'}}
      />
    );
  }

  export function otpMask(props) {
    const { inputRef, onChange, ...other } = props;
    
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        allowEmptyFormatting={true}
        mask={'_'}
        format='# # # # # #'
        style={{fontFamily:'SommetRoundedLight',fontSize:'16px'}}
      />
    );
  }

  export function fibakodNewMask(props) {
    const { inputRef, onChange, ...other } = props;
    
    return (
      <InputMask
        {...other}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        alwaysShowMask={true}
        maskChar={'_'}
        mask='*'
        type="text"
        style={{fontFamily:'SommetRoundedLight',fontSize:'18px', textAlign:'center'}}
      />
    );
  }